export const sinclairTheme = 'SINCLAIR-PROSSER'

